module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro2.99daa18d.mp3";